import axiosInstance from "./axios.config";

export async function addSeason(data) {
  try {
    const response = await axiosInstance.post("/seasons", data);

    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}
export async function getSeason(season_id) {
  try {
    const response = await axiosInstance.get(
      `/seasons/${season_id}`
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}
export async function updateSeason(season_id, data) {
  try {
    const response = await axiosInstance.post(
      `/seasons?season_id=${season_id}`,
      data
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "An error occurred during login";
  }
}
